const employmentStatus = ["Employed (full time)", "Employed (part time)", "Self Employed", "Unemployed", "Student", "Retired"];
export default employmentStatus;